import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { PDFDocument, StandardFonts } from 'pdf-lib';
import { FileHelper } from 'src/app/helpers';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-certificate-fhe',
  templateUrl: './certificate-fhe.component.html',
  styleUrls: ['./certificate-fhe.component.css']
})
export class CertificateFheComponent implements OnInit {
  src: string = "../../../../../assets/certificate.pdf";

  // User object
  user = {
    firstName: '',
    middleInitial: '',
    lastName: '',
  }

  constructor(private auth: AuthService) { }

  // When the page is loaded, pull the profile infomation
  ngOnInit(): void {
    // Use auth service to send request
    this.auth.getProfile().toPromise().then((profile: any) => {

      // Assign response to user object
      this.user = profile.user;
    });
  }

  async createPdf () {

    // Grab the template pdf
    const url = "../../../../../assets/certificate-blank.pdf";
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes)

    // Embed the Times Roman font
    const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)

    // Grab first (and only) page of the document
    const page = pdfDoc.getPages()[0];

    // Get the width and height of the page
    const { width, height } = page.getSize()

    // Draw the user's name
    const fontSize = 30
    const name = this.user.firstName + " " + this.user.lastName
    const nameWidth = timesRomanFont.widthOfTextAtSize(name, fontSize)
    page.drawText(name, {
      x: width/2 - nameWidth/2,
      y: height - 4.2 * fontSize,
      size: fontSize,
      font: timesRomanFont,
    })

    // Draw the date of completion
    // TODO: Replace with completion date associated with the user's certificate in the database
    const completionDate = Date.now();
    const dateString = formatDate(completionDate, 'longDate', 'en-US')
    const dateWidth = timesRomanFont.widthOfTextAtSize(dateString, fontSize)
    page.drawText(dateString, {
      x: width/2 - dateWidth/2,
      y: height - 9 * fontSize,
      size: fontSize,
      font: timesRomanFont,
    })

    // TODO: Draw the following values on the certificate: Instructor/Coordinator, Agency, Agency Phone #, Agency Logo

    // Serialize the PDFDocument to bytes (a Uint8Array)
    const pdfBytes = await pdfDoc.save()
    FileHelper.saveByteArray('certificate.pdf', pdfBytes, 'application/pdf');
  }
}
